import api from 'Common/Client/Interceptor';


const courseCategoryService = {
  // Fetch all course categories with details
getCourseCategories: async (onlyWithSubCategories = true, pageNumber = 1, pageSize = 10) => {
  try {
    const response = await api.get(`/indv/CourseCategory/list-with-details`, {
      params: {
        onlyWithSubCategories,
        pageNumber,
        pageSize
      }
    });
    console.log("******************************VVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVin serivce categories",response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching course categories:", error);
    throw error;
  }
},



  createInterest: async (subCategoryIds) => {
    try {
      const response = await api.post(
        `/indv/CourseCategory/learner/create-interest`,
        {
          subCategoryIds: subCategoryIds
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error creating interest:', error);
      throw error;
    }
  }
};

export const fetchInterestData = async () => {
  try {
    const response = await api.get("/indv/CourseCategory/learner/get-interest");

    console.log("................ self learners data:", response.data);
    return response.data;
  } catch (error) {
    console.error(" Error fetching PRO Admin dashboard data:", error);
    throw error;
  }
};


export default courseCategoryService;